import Vue from 'vue';
import moment from 'moment';

Vue.filter('date', (value: Date, format: string) => {
	if (!value) {
		return '';
	}

	return moment(value).format(format || 'DD MM YYYY');
});
